import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _bulkUpdateAllSitesOfUserRequest = { state: '_v1State' };
var _bulkUpdateAllSitesOfUserResponse = {};
var _bulkUpdateStateAcrossSitesRequest = { statePerSite: '_statePerSite' };
var _bulkUpdateStateAcrossSitesResponse = {};
var _bulkUpdateUsersNotificationPreferenceStatesRequest = {
    state: '_v1State',
};
var _bulkUpdateUsersNotificationPreferenceStatesResponse = {};
var _channelPreferences = { stateData: '_stateData' };
var _getNotificationTopicsDefinitionsRequest = {};
var _getNotificationTopicsDefinitionsResponse = {};
var _getPreferencesByImplicitRecipientRequest = {};
var _getPreferencesByImplicitRecipientResponse = {
    notificationPreferences: '_notificationPreferences',
};
var _getPreferencesByRecipientRequest = {};
var _getPreferencesByRecipientResponse = {
    notificationPreferences: '_notificationPreferences',
};
var _getPreferencesRequest = {};
var _getPreferencesResponse = {
    notificationPreferences: '_notificationPreferences',
};
var _getSendabilityStatusInAllChannelsRequest = {};
var _getSendabilityStatusInAllChannelsResponse = {};
var _getSendabilityStatusRequest = {};
var _getSendabilityStatusResponse = {};
var _getStateOfSitesRequest = {};
var _getStateOfSitesResponse = { statePerSite: '_statePerSite' };
var _getUnsubscribeFromNotificationTopicPageUrlRequest = {};
var _getUnsubscribeFromNotificationTopicPageUrlResponse = {};
var _listChannelPreferencesRequest = {};
var _listChannelPreferencesResponse = {
    channelsPreferences: '_channelPreferences',
};
var _listSendabilityStatusRequest = {};
var _listSendabilityStatusResponse = {};
var _notificationPreferences = { preferencesInfo: '_preferenceInfo' };
var _preferenceInfo = { stateData: '_stateData' };
var _stateData = { state: '_v1State' };
var _statePerSite = { state: '_v1State' };
var _upsertPreferencesByImplicitRecipientRequest = {
    preferencesInfo: '_preferenceInfo',
};
var _upsertPreferencesByImplicitRecipientResponse = {
    preferences: '_notificationPreferences',
};
var _upsertPreferencesByRecipientRequest = {
    preferences: '_notificationPreferences',
};
var _upsertPreferencesByRecipientResponse = {
    preferences: '_notificationPreferences',
};
var _upsertPreferencesRequest = { preferencesInfo: '_preferenceInfo' };
var _upsertPreferencesResponse = { preferences: '_notificationPreferences' };
var _v1State = {
    startDate: 'google.protobuf.Timestamp',
    endDate: 'google.protobuf.Timestamp',
};
function resolveWixNotificationsV1NotificationPreferencesServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/notifications',
                destPath: '',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/notification-preferences',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/notification-preferences',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/notification-preferences',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Upsert a Preferences by recipient */
export function upsertPreferencesByRecipient(payload) {
    var _a = serializer(_upsertPreferencesByRecipientRequest, { _notificationPreferences: _notificationPreferences, _preferenceInfo: _preferenceInfo, _stateData: _stateData, _v1State: _v1State }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_upsertPreferencesByRecipientResponse, { _notificationPreferences: _notificationPreferences, _preferenceInfo: _preferenceInfo, _stateData: _stateData, _v1State: _v1State }).fromJSON;
    function __upsertPreferencesByRecipient(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.notifications.v1.notification_preferences',
            method: 'POST',
            methodFqn: 'wix.notifications.v1.NotificationPreferencesService.UpsertPreferencesByRecipient',
            url: resolveWixNotificationsV1NotificationPreferencesServiceUrl({
                protoPath: '/v1/preferences',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __upsertPreferencesByRecipient.fromReq = fromReq;
    __upsertPreferencesByRecipient.__isAmbassador = true;
    return __upsertPreferencesByRecipient;
}
/** Upsert a Preferences by implicit recipient */
export function upsertPreferencesByImplicitRecipient(payload) {
    var _a = serializer(_upsertPreferencesByImplicitRecipientRequest, { _preferenceInfo: _preferenceInfo, _stateData: _stateData, _v1State: _v1State }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_upsertPreferencesByImplicitRecipientResponse, { _notificationPreferences: _notificationPreferences, _preferenceInfo: _preferenceInfo, _stateData: _stateData, _v1State: _v1State }).fromJSON;
    function __upsertPreferencesByImplicitRecipient(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.notifications.v1.notification_preferences',
            method: 'POST',
            methodFqn: 'wix.notifications.v1.NotificationPreferencesService.UpsertPreferencesByImplicitRecipient',
            url: resolveWixNotificationsV1NotificationPreferencesServiceUrl({
                protoPath: '/v1/preferences-by-implicit-recipient',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __upsertPreferencesByImplicitRecipient.fromReq = fromReq;
    __upsertPreferencesByImplicitRecipient.__isAmbassador = true;
    return __upsertPreferencesByImplicitRecipient;
}
export function upsertPreferences(payload) {
    var _a = serializer(_upsertPreferencesRequest, { _preferenceInfo: _preferenceInfo, _stateData: _stateData, _v1State: _v1State }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_upsertPreferencesResponse, {
        _notificationPreferences: _notificationPreferences,
        _preferenceInfo: _preferenceInfo,
        _stateData: _stateData,
        _v1State: _v1State,
    }).fromJSON;
    function __upsertPreferences(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.notifications.v1.notification_preferences',
            method: 'POST',
            methodFqn: 'wix.notifications.v1.NotificationPreferencesService.UpsertPreferences',
            url: resolveWixNotificationsV1NotificationPreferencesServiceUrl({
                protoPath: '/v1/notification-preferences',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __upsertPreferences.fromReq = fromReq;
    __upsertPreferences.__isAmbassador = true;
    return __upsertPreferences;
}
/** Get a Preferences by recipient id */
export function getPreferencesByRecipient(payload) {
    var _a = serializer(_getPreferencesByRecipientRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getPreferencesByRecipientResponse, {
        _notificationPreferences: _notificationPreferences,
        _preferenceInfo: _preferenceInfo,
        _stateData: _stateData,
        _v1State: _v1State,
    }).fromJSON;
    function __getPreferencesByRecipient(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.notifications.v1.notification_preferences',
            method: 'GET',
            methodFqn: 'wix.notifications.v1.NotificationPreferencesService.GetPreferencesByRecipient',
            url: resolveWixNotificationsV1NotificationPreferencesServiceUrl({
                protoPath: '/v1/preferences',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getPreferencesByRecipient.fromReq = fromReq;
    __getPreferencesByRecipient.__isAmbassador = true;
    return __getPreferencesByRecipient;
}
/** Get Preferences */
export function getPreferences(payload) {
    var _a = serializer(_getPreferencesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getPreferencesResponse, {
        _notificationPreferences: _notificationPreferences,
        _preferenceInfo: _preferenceInfo,
        _stateData: _stateData,
        _v1State: _v1State,
    }).fromJSON;
    function __getPreferences(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.notifications.v1.notification_preferences',
            method: 'GET',
            methodFqn: 'wix.notifications.v1.NotificationPreferencesService.GetPreferences',
            url: resolveWixNotificationsV1NotificationPreferencesServiceUrl({
                protoPath: '/v1/notification-preferences',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveWixNotificationsV1NotificationPreferencesServiceUrl({
                        protoPath: '/v1/notification-preferences',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __getPreferences.fromReq = fromReq;
    __getPreferences.__isAmbassador = true;
    return __getPreferences;
}
export function getPreferencesByImplicitRecipient(payload) {
    var _a = serializer(_getPreferencesByImplicitRecipientRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getPreferencesByImplicitRecipientResponse, { _notificationPreferences: _notificationPreferences, _preferenceInfo: _preferenceInfo, _stateData: _stateData, _v1State: _v1State }).fromJSON;
    function __getPreferencesByImplicitRecipient(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.notifications.v1.notification_preferences',
            method: 'GET',
            methodFqn: 'wix.notifications.v1.NotificationPreferencesService.GetPreferencesByImplicitRecipient',
            url: resolveWixNotificationsV1NotificationPreferencesServiceUrl({
                protoPath: '/v1/preferences-by-implicit-recipient',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getPreferencesByImplicitRecipient.fromReq = fromReq;
    __getPreferencesByImplicitRecipient.__isAmbassador = true;
    return __getPreferencesByImplicitRecipient;
}
/** Get a Preferences by recipient id */
export function getSendabilityStatus(payload) {
    var _a = serializer(_getSendabilityStatusRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getSendabilityStatusResponse, {}).fromJSON;
    function __getSendabilityStatus(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.notifications.v1.notification_preferences',
            method: 'GET',
            methodFqn: 'wix.notifications.v1.NotificationPreferencesService.GetSendabilityStatus',
            url: resolveWixNotificationsV1NotificationPreferencesServiceUrl({
                protoPath: '/v1/preferences/sendability-status',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getSendabilityStatus.fromReq = fromReq;
    __getSendabilityStatus.__isAmbassador = true;
    return __getSendabilityStatus;
}
export function getSendabilityStatusInAllChannels(payload) {
    var _a = serializer(_getSendabilityStatusInAllChannelsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getSendabilityStatusInAllChannelsResponse, {}).fromJSON;
    function __getSendabilityStatusInAllChannels(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.notifications.v1.notification_preferences',
            method: 'GET',
            methodFqn: 'wix.notifications.v1.NotificationPreferencesService.GetSendabilityStatusInAllChannels',
            url: resolveWixNotificationsV1NotificationPreferencesServiceUrl({
                protoPath: '/v1/preferences/sendability-status-all-channels',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getSendabilityStatusInAllChannels.fromReq = fromReq;
    __getSendabilityStatusInAllChannels.__isAmbassador = true;
    return __getSendabilityStatusInAllChannels;
}
export function listSendabilityStatus(payload) {
    var _a = serializer(_listSendabilityStatusRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listSendabilityStatusResponse, {}).fromJSON;
    function __listSendabilityStatus(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.notifications.v1.notification_preferences',
            method: 'GET',
            methodFqn: 'wix.notifications.v1.NotificationPreferencesService.ListSendabilityStatus',
            url: resolveWixNotificationsV1NotificationPreferencesServiceUrl({
                protoPath: '/v1/preferences/list-sendability-status',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listSendabilityStatus.fromReq = fromReq;
    __listSendabilityStatus.__isAmbassador = true;
    return __listSendabilityStatus;
}
export function listChannelPreferences(payload) {
    var _a = serializer(_listChannelPreferencesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listChannelPreferencesResponse, {
        _channelPreferences: _channelPreferences,
        _stateData: _stateData,
        _v1State: _v1State,
    }).fromJSON;
    function __listChannelPreferences(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.notifications.v1.notification_preferences',
            method: 'GET',
            methodFqn: 'wix.notifications.v1.NotificationPreferencesService.ListChannelPreferences',
            url: resolveWixNotificationsV1NotificationPreferencesServiceUrl({
                protoPath: '/v1/preferences/channels',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listChannelPreferences.fromReq = fromReq;
    __listChannelPreferences.__isAmbassador = true;
    return __listChannelPreferences;
}
export function getNotificationTopicsDefinitions(payload) {
    var _a = serializer(_getNotificationTopicsDefinitionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getNotificationTopicsDefinitionsResponse, {}).fromJSON;
    function __getNotificationTopicsDefinitions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.notifications.v1.notification_preferences',
            method: 'GET',
            methodFqn: 'wix.notifications.v1.NotificationPreferencesService.GetNotificationTopicsDefinitions',
            url: resolveWixNotificationsV1NotificationPreferencesServiceUrl({
                protoPath: '/v1/preferences/topics',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getNotificationTopicsDefinitions.fromReq = fromReq;
    __getNotificationTopicsDefinitions.__isAmbassador = true;
    return __getNotificationTopicsDefinitions;
}
export function getUnsubscribeFromNotificationTopicPageUrl(payload) {
    var _a = serializer(_getUnsubscribeFromNotificationTopicPageUrlRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getUnsubscribeFromNotificationTopicPageUrlResponse, {}).fromJSON;
    function __getUnsubscribeFromNotificationTopicPageUrl(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.notifications.v1.notification_preferences',
            method: 'GET',
            methodFqn: 'wix.notifications.v1.NotificationPreferencesService.GetUnsubscribeFromNotificationTopicPageUrl',
            url: resolveWixNotificationsV1NotificationPreferencesServiceUrl({
                protoPath: '/v1/preferences/unsubscribe-page',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getUnsubscribeFromNotificationTopicPageUrl.fromReq = fromReq;
    __getUnsubscribeFromNotificationTopicPageUrl.__isAmbassador = true;
    return __getUnsubscribeFromNotificationTopicPageUrl;
}
export function bulkUpdateStateAcrossSites(payload) {
    var _a = serializer(_bulkUpdateStateAcrossSitesRequest, { _statePerSite: _statePerSite, _v1State: _v1State }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateStateAcrossSitesResponse, {}).fromJSON;
    function __bulkUpdateStateAcrossSites(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.notifications.v1.notification_preferences',
            method: 'POST',
            methodFqn: 'wix.notifications.v1.NotificationPreferencesService.BulkUpdateStateAcrossSites',
            url: resolveWixNotificationsV1NotificationPreferencesServiceUrl({
                protoPath: '/v1/bulk/preferences/state-across-sites',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateStateAcrossSites.fromReq = fromReq;
    __bulkUpdateStateAcrossSites.__isAmbassador = true;
    return __bulkUpdateStateAcrossSites;
}
export function getBulkStateOfSite(payload) {
    var _a = serializer(_getStateOfSitesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getStateOfSitesResponse, {
        _statePerSite: _statePerSite,
        _v1State: _v1State,
    }).fromJSON;
    function __getBulkStateOfSite(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.notifications.v1.notification_preferences',
            method: 'GET',
            methodFqn: 'wix.notifications.v1.NotificationPreferencesService.GetBulkStateOfSite',
            url: resolveWixNotificationsV1NotificationPreferencesServiceUrl({
                protoPath: '/v1/bulk/preferences/state-across-sites',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getBulkStateOfSite.fromReq = fromReq;
    __getBulkStateOfSite.__isAmbassador = true;
    return __getBulkStateOfSite;
}
export function bulkUpdateAllSitesOfUser(payload) {
    var _a = serializer(_bulkUpdateAllSitesOfUserRequest, { _v1State: _v1State }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateAllSitesOfUserResponse, {}).fromJSON;
    function __bulkUpdateAllSitesOfUser(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.notifications.v1.notification_preferences',
            method: 'POST',
            methodFqn: 'wix.notifications.v1.NotificationPreferencesService.BulkUpdateAllSitesOfUser',
            url: resolveWixNotificationsV1NotificationPreferencesServiceUrl({
                protoPath: '/v1/bulk/preferences/state-of-all-sites',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateAllSitesOfUser.fromReq = fromReq;
    __bulkUpdateAllSitesOfUser.__isAmbassador = true;
    return __bulkUpdateAllSitesOfUser;
}
export function bulkUpdateUsersNotificationPreferenceStates(payload) {
    var _a = serializer(_bulkUpdateUsersNotificationPreferenceStatesRequest, { _v1State: _v1State }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateUsersNotificationPreferenceStatesResponse, {}).fromJSON;
    function __bulkUpdateUsersNotificationPreferenceStates(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.notifications.v1.notification_preferences',
            method: 'POST',
            methodFqn: 'wix.notifications.v1.NotificationPreferencesService.BulkUpdateUsersNotificationPreferenceStates',
            url: resolveWixNotificationsV1NotificationPreferencesServiceUrl({
                protoPath: '/v1/bulk/preferences/user-notification-preferences-states',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateUsersNotificationPreferenceStates.fromReq = fromReq;
    __bulkUpdateUsersNotificationPreferenceStates.__isAmbassador = true;
    return __bulkUpdateUsersNotificationPreferenceStates;
}
//# sourceMappingURL=http.impl.js.map